import {Component, inject, signal} from '@angular/core';
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {FormGroup} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatStep, MatStepper, MatStepperNext} from "@angular/material/stepper";
import {RecordData, RecordDataValue} from "../../../types/records-table.types";
import {defaultRecordData} from "../../../models/default-record-data";
import {CommonModule} from '@angular/common';
import {FormatNumberPipe} from "../../../../shared/pipes/format-number.pipe";
import {AddCooperationOfferService} from "./services/add-cooperation-offer.service";
import {addCooperationOfferFormFields, addCooperationOfferModalName} from "./configs/add-cooperation-offer-config";
import {FormCooperationOfferComponent} from "./components/form-cooperation-offer/form-cooperation-offer.component";

@Component({
  selector: 'app-add-cooperation-offer',
  standalone: true,
  imports: [
    CommonModule,
    MatButton,
    MatStepper,
    MatStep,
    MatStepperNext,
    FormatNumberPipe,
    BaseModalComponent,
    FormCooperationOfferComponent
  ],
  templateUrl: './add-cooperation-offer.component.html',
  styleUrl: './add-cooperation-offer.component.scss'
})
export class AddCooperationOfferComponent extends BaseModalComponent {
  private addCooperationOfferService: AddCooperationOfferService = inject(AddCooperationOfferService);

  public formGroup: FormGroup = new FormGroup({});
  public readonly Number = Number;
  public repeatsData = signal<Array<RecordData>>([]);

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(addCooperationOfferModalName);
    this.isMobile = this.deviceService.isMobile;
    this.formGroup = this.baseModalService.getFormGroup(addCooperationOfferFormFields);
    this.initSubscriptions();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(addCooperationOfferModalName);
  }

  public async nextStep(): Promise<void> {
    const queryParams = {
      channelUrl: this.formGroup.value['channelUrl'],
      channelName: this.formGroup.value['channelName'],
      displayedChannelName: this.formGroup.value['displayedChannelName']
    }

    const data = await this.addCooperationOfferService.getSearchRepeatsForRecordsList(queryParams)
      .catch(() => []);
    this.repeatsData.set(data);
  }

  public async createRepeat() {
    const repeatData = await this.addNewRecord('record-lists', this.formGroup.value)
      .catch(() => defaultRecordData);

    this.formGroup.patchValue(repeatData)
  }

  public getManagerNameColorClass(isOwn: RecordDataValue): string {
    return isOwn ? 'manager-name-color-green' : 'manager-name-color-blue';
  }

  public override initSubscriptions(): void {
    this.initIsMobileSubscription();
  }

  private initIsMobileSubscription(): void {
    this.subscriptions.add(
      this.deviceService.isMobile$.subscribe((isMobile: boolean) => {
        this.isMobile = isMobile;
      })
    );
  }
}
